import React, { useState } from 'react';
import { HelpIcon, Panel, useMatchScreenWidth } from '@keplerco/core';
import { SkillLevelsExplainerPanelLayout } from '../../../widgets/layouts/focus-panel-layouts/skill-levels-explainer-panel/skill-levels-explainer-panel.layout';
import { useAppState } from '../../../overmind';
import { TertiaryButton } from '../tertiary-button/tertiary-button';

export default function SkillLevelHelp(): React.ReactElement {
  const { companyVariables } = useAppState();
  const [open, setOpen] = useState(false);
  const isMobile = useMatchScreenWidth('mobile');

  if (!companyVariables.useLevels) return <React.Fragment />;

  return (
    <React.Fragment>
      <TertiaryButton onClick={() => setOpen(true)} type="button" aria-label="Open skill level explainer panel">
        <HelpIcon tone="secondary" />
        {!isMobile && <span style={{ textWrap: 'nowrap' }}>Skill levels</span>}
      </TertiaryButton>

      <Panel open={open} onClose={() => setOpen(false)}>
        <SkillLevelsExplainerPanelLayout onClose={() => setOpen(false)} />
      </Panel>
    </React.Fragment>
  );
}
